import React from 'react';
import PropTypes from 'prop-types';
import styles from './Textarea.module.scss';

const Textarea = ({
  label,
  error,
  helperText,
  id,
  className,
  ...rest
}) => {
  const wrapperClasses = [styles.wrapper, className || ''].filter(Boolean).join(' ');
  const textareaClasses = [styles.textarea, error ? styles.textareaError : '']
    .filter(Boolean)
    .join(' ');

  return (
    <div className={wrapperClasses}>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
      <textarea id={id} className={textareaClasses} {...rest} />
      {error && <span className={styles.error}>{error}</span>}
      {!error && helperText && <span className={styles.helperText}>{helperText}</span>}
    </div>
  );
};

Textarea.propTypes = {
  label: PropTypes.string,
  error: PropTypes.string,
  helperText: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
};

Textarea.defaultProps = {
  label: '',
  error: '',
  helperText: '',
  id: undefined,
  className: '',
};

export default Textarea;
